import { render, staticRenderFns } from "./CreateFromTemplate.vue?vue&type=template&id=ddb9fe12&"
import script from "./CreateFromTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports